import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RateLimitService {
  private readonly MAX_ATTEMPTS = 5;
  private readonly LOCKOUT_TIME = 5 * 60 * 1000; // 5 minutes
  private readonly STORAGE_KEY = 'login_attempts';

  getAttempts(): { count: number; lastAttempt: number } {
    const stored = sessionStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
    return { count: 0, lastAttempt: 0 };
  }

  recordFailedAttempt(): void {
    const attempts = this.getAttempts();
    attempts.count += 1;
    attempts.lastAttempt = Date.now();
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(attempts));
  }

  recordSuccessfulLogin(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }

  isLockedOut(): boolean {
    const attempts = this.getAttempts();
    if (attempts.count >= this.MAX_ATTEMPTS) {
      const timeSinceLastAttempt = Date.now() - attempts.lastAttempt;
      return timeSinceLastAttempt < this.LOCKOUT_TIME;
    }
    return false;
  }

  getRemainingLockoutTime(): number {
    const attempts = this.getAttempts();
    const timeSinceLastAttempt = Date.now() - attempts.lastAttempt;
    return Math.max(0, this.LOCKOUT_TIME - timeSinceLastAttempt);
  }

  shouldShowCaptcha(): boolean {
    return this.getAttempts().count >= 2;
  }
}